import React from 'react';
import SEO from '../components/common/SEO';
import HeroSection from '../components/sections/HeroSection';
import ValuePropositionSection from '../components/sections/ValuePropositionSection';
import BrandStorySection from '../components/sections/BrandStorySection';
import TemplateMarqueeSection from '../components/sections/TemplateMarqueeSection';
import ClientNotesSection from '../components/sections/ClientNotesSection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'SeaSalt Creative by Princy Patel',
  founder: {
    '@type': 'Person',
    name: 'Princy Patel'
  },
  url: 'https://seasaltcreative.com',
  logo: 'https://seasaltcreative.com/logo192.png',
  description: 'Custom website design studio founded by Princy Patel, crafting elevated, responsive sites for wellness and creative brands.'
};

const Home = () => {
  return (
    <>
      <SEO
        title="Website Design for Photographers & Videographers"
        description="SeaSalt Creative by Princy Patel is a web design studio crafting custom websites and portfolio designs for photographers, videographers, creative studios, and wellness brands."
        keywords="princy patel, princy, web designer princy patel, princy seasalt creative, sea, salt, creative, seasalt creative, seasalt, seasalt creative studio, seasalt creative web design, photography website design, photographer website builder, videographer website design, video portfolio website, creative studio web design"
        schemaData={organizationSchema}
      />
      <HeroSection />
      <BrandStorySection />
      <ValuePropositionSection />
      <TemplateMarqueeSection />
      <ClientNotesSection />
    </>
  );
};

export default Home;
